import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import ServicesOverview from "./components/ServicesOverview";
import HowItWorks from "./components/HowItWorks";
import ContactSection from "./components/ContactSection";
import LoginSection from "./components/LoginSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-farm-cream font-body">
      <Navbar />
      <main>
        <HeroSection />
        <LoginSection />
        <ServicesOverview />
        <HowItWorks />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
